import { Component, inject, Input, OnInit } from '@angular/core'
import { CommonModule, DatePipe } from '@angular/common'
import { IonicModule, ModalController } from '@ionic/angular'
import { PrivateMessage } from '../../../models/privateMessage'
import { FileUploadService } from '../../../services/file-upload.service'
import { DomSanitizer } from '@angular/platform-browser'
import { FileViewerService } from '../../../services/fileViewer/file-viewer.service'
import { BypassHtmlSanitizerPipe } from '../../../shared/pipes/bypass-html-sanitizer.pipe'
import { FileSizePipe } from '../../../shared/pipes/file-size.pipe'

@Component({
  selector: 'app-private-message-viewer',
  standalone: true,
  imports: [CommonModule, IonicModule, DatePipe, BypassHtmlSanitizerPipe],
  templateUrl: './private-message-viewer.component.html',
  styleUrls: ['./private-message-viewer.component.scss'],
})
export class PrivateMessageViewerComponent implements OnInit {
  private modalCtrl = inject(ModalController)
  sanitizer = inject(DomSanitizer)
  private fileViewerService = inject(FileViewerService)

  @Input() message: PrivateMessage

  FileUploadService = FileUploadService

  ngOnInit() {}

  close() {
    this.modalCtrl.dismiss()
  }

  replyToMessage() {
    this.modalCtrl.dismiss('reply')
  }

  viewAttachment(msg: PrivateMessage) {
    if (msg.attachmentUri) {
      const attachmentName = FileUploadService.parseFileNameFromUrl(msg.attachmentUri)
      this.fileViewerService.viewIfPdfElseDownload(msg.attachmentUri)
    }
  }
}
